class UserGroup {
  constructor(title, description) {
    this.title = title;
    this.description = description;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allUserGroups: [],
      allUserGroupsForOther: [],
      userGroup: new UserGroup('', ''),
      userGroupPaginationList: [],
    };
  },
  methods: {
    getListOfUserGroupsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllUserGroups').then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          this.allUserGroupsForOther = this.$store.state.userGroupModule.allUserGroups;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfUserGroupsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfUserGroupsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllUserGroups: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllUserGroups').then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          this.allUserGroups = this.$store.state.userGroupModule.allUserGroups;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllUserGroups();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllUserGroups();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfUserGroupsWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getUserGroupsWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
        })
        .then(() => {
          if (this.$store.state.userGroupModule.successFlag) {
            this.userGroupPaginationList = [];
            let temp = this.$store.state.userGroupModule.userGroups;
            for (let i = 0; i < temp.length; i++) {
              this.userGroupPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                description: temp[i].description ? temp[i].description : '-',
                id: temp[i].id,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.userGroupModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.userGroupModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.userGroupModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.userGroupModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfUserGroupsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.userGroupModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfUserGroupsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addUserGroupFunction: function () {
      if (!this.userGroup.title) {
        this.snackText = 'عنوان گروه کاربری نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.userGroup.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان گروه کاربری نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addUserGroup', this.userGroup).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' گروه کاربری با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.userGroup = new UserGroup('', '');
          this.getListOfUserGroupsWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addUserGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addUserGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getUserGroupFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getUserGroup', id).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          let temp = this.$store.state.userGroupModule.userGroup;
          this.userGroup.id = temp.id;
          this.userGroup.title = temp.title;
          this.userGroup.description = temp.description;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserGroupFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserGroupFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editUserGroupFunction: function () {
      if (!this.userGroup.title) {
        this.snackText = 'عنوان گروه کاربری نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.userGroup.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان گروه کاربری نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editUserGroup', this.userGroup).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfUserGroupsWithPagination();
          this.snackText = ' گروه کاربری با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.userGroup = new UserGroup('', '');
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editUserGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editUserGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteUserGroupFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteUserGroup', this.userGroupId).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfUserGroupsWithPagination();
          this.snackText = ' گروه کاربری با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteUserGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteUserGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //permission part
    getUserGroupPermissionList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('userGroupPrmissions', this.userGroupId).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          if (this.$route.name == 'userGroup') {
            this.allUserGroupSelectedPermissions =
              this.$store.state.userGroupModule.userGroupPermisions;
            this.defineUserGroupPermissions();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserGroupPermissionList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserGroupPermissionList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditUserGroupPermissionFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        userGroupId: this.userGroupId,
        features: [],
      };
      for (let i = 0; i < this.allUserGroupSelectedPermissions.length; i++) {
        data.features.push(Number(this.allUserGroupSelectedPermissions[i].id));
      }
      this.$store.dispatch('editUserGroupPermission', data).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' سطح های دسترسی گروه کاربری با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.allUserGroupSelectedPermissions = [];
          this.allUserGroupPermissions = [];
          this.permissionModal = false;
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditUserGroupPermissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditUserGroupPermissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //role part
    getUserGroupRoleList: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('userGroupRoles', this.userGroupId).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          if (this.$route.name == 'userGroup') {
            this.allUserGroupSelectedRoles = this.$store.state.userGroupModule.userGroupRoles;
            this.defineUserGroupRoles();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserGroupRoleList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserGroupRoleList();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    EditUserGroupRoleFunction: function () {
      /*if (this.allUserGroupSelectedRoles.length == 0) {
                this.snackText = "انتخاب حداقل یک نقش اجباری است.";
                this.$refs.snackRef.snackModel = true;
                this.snackColor = "#FF5252";
                this.snakIcon = "mdi-information";
                this.disabelConfirm = false;
                return;
            }*/
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        userGroupId: this.userGroupId,
        features: [],
      };
      for (let i = 0; i < this.allUserGroupSelectedRoles.length; i++) {
        data.features.push(Number(this.allUserGroupSelectedRoles[i].id));
      }
      this.$store.dispatch('editUserGroupRole', data).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = ' نقش های گروه کاربری با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.allUserGroupSelectedRoles = [];
          this.allUserGroupRoles = [];
          this.roleModal = false;
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.EditUserGroupRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.EditUserGroupRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    //users
    getUserGroupUsersNotInGroupFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getUserGroupUsersNotInGroup', {
          groupId: this.userGroupId,
          pageNumber: this.page,
          pageSize: this.pageSize,
        })
        .then(() => {
          if (this.$store.state.userGroupModule.successFlag) {
            this.allUsersNotInGroup = this.$store.state.userGroupModule.userGroupUsersNotInGroup;

            this.totalPages = Number(this.$store.state.userGroupModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.userGroupModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.userGroupModule.totalRecords);
            }
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.userGroupModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getUserGroupUsersNotInGroupFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.userGroupModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getUserGroupUsersNotInGroupFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getUserGroupUsersInGroupFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getUserGroupUsersInGroup', this.userGroupId).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          this.allUsersInGroup = this.$store.state.userGroupModule.userGroupUsersInGroup;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUserGroupUsersInGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUserGroupUsersInGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setUsersOfGroupFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        userGroupId: this.userGroupId,
        features: [],
      };
      for (let i = 0; i < this.allUsersInGroup.length; i++) {
        data.features.push(Number(this.allUsersInGroup[i].id));
      }
      this.$store.dispatch('setUsersOfGroup', data).then(() => {
        if (this.$store.state.userGroupModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.$router.push({ name: 'userGroup' });
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGroupModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setUsersOfGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGroupModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setUsersOfGroupFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.userGroupModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
